import { notification } from "antd";
import subscriptionService from "../Service/subscription.service";

interface SubscriptionCheckResult {
  canAddPost: boolean;
  message?: string;
}

export const checkSubscriptionStatus =
  async (): Promise<SubscriptionCheckResult> => {
    const accessResponse = await subscriptionService.getCurrentAccess();
    const processedJobPosts =
      accessResponse?.subscription?.measurements.jobPosts;
    const limit = accessResponse?.limits?.jobPosts;
    const status = accessResponse?.subscription?.status;

    if (limit === -1 && status === "active") {
      return {
        canAddPost: true,
      };
    }

    if (limit && processedJobPosts && processedJobPosts >= limit) {
      return {
        canAddPost: false,
        message: `Your current subscription plan allows only ${limit} active job posts. Please upgrade to post more.`,
      };
    }

    if (status === "inactive") {
      return {
        canAddPost: false,
        message: "Please upgrade your pack to enjoy your benefits.",
      };
    }

    return { canAddPost: true };
  };

export const showSubscriptionNotification = (message: string) => {
  notification.warning({
    message: "Upgrade Required",
    description: message,
  });
};
